query MfaIssue($runId: ConditionID!, $issueId: ConditionID!) {
	issues(run_id_eq: $runId, issue_id_eq: $issueId, deleted_eq: { value: false }) {
		scan_name
		scan_id
		elements__index
	}
	mfa_session_runs(run_id_eq: $runId) {
		session_name
	}
}
